import { render, staticRenderFns } from "./JobCommentList.vue?vue&type=template&id=db393f84&scoped=true&"
import script from "./JobCommentList.vue?vue&type=script&lang=js&"
export * from "./JobCommentList.vue?vue&type=script&lang=js&"
import style0 from "./JobCommentList.vue?vue&type=style&index=0&id=db393f84&lang=scss&scoped=true&"
import style1 from "./JobCommentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db393f84",
  null
  
)

export default component.exports